import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { getModelById, getDownloadLink, updateModel, patchModel } from '../../utils/api';
import '../../App.css';
import HeadGallery from './HeadGallery';
import { SiteContext } from '../../App';
import PageView from './PageView';
import PageEditView from './PageEditView';
import { fetchModelAssets } from '../../utils/models/fetchModelAssets';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import PDFModel from './PDFModel';



const PageParent = () => {
    const { isEditMode } = useContext(SiteContext);
    const { id } = useParams();
    const [model, setModel] = useState(null);
    const [assets, setAssets] = useState(null);
    const [currentThumbnail, setCurrentThumbnail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { setExportModelToPDF } = useContext(SiteContext);

    const generatePDFForModel = async () => {
        if (!model) return;
        const blob = await pdf(<PDFModel model={model} assets={assets} />).toBlob();
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `${model.firstName}_${model.lastName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        console.log('modelpage.model', model);
        // Register the export function when the model is loaded
        if (model) {
            console.log('modelisSet', model);
            setExportModelToPDF(() => () => generatePDFForModel(model));
        }

        // Cleanup when leaving the page
        return () => setExportModelToPDF(null);
    }, [model, setExportModelToPDF]);

    useEffect(() => {
        const fetchModelAndAssets = async () => {
            var modelData = null;
            try {
                const response = await getModelById(id);
                modelData = response.data;
                setModel(modelData);


            } catch (err) {
                console.error('Failed to fetch model', err);
                setError('Failed to fetch model. Please try again later.');
                setLoading(false);
            }

            if (!error && modelData != null) {
                const modelAssets = await fetchModelAssets(modelData);
                setAssets(modelAssets);
                setCurrentThumbnail(modelAssets?.thumbnail.file);
                setLoading(false);
            }
        };

        fetchModelAndAssets();
    }, [id, isEditMode]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;
    if (!model) return <div>No model data available.</div>;

    const allImages = [
        ...(assets.primaryImages || []),
        ...(assets.secondaryImages || [])
    ];


    return (
        <div className='container'>
            {allImages.length > 0 && (
                <HeadGallery
                    currentThumbnail={currentThumbnail || allImages[0].file || '/path/to/fallback/image.jpg'}
                    onThumbnailSelect={setCurrentThumbnail}
                    model={model}
                    assets={assets}
                />
            )}

            {!isEditMode ? (
                <PageView model={model} assets={assets} />
            ) : (
                <PageEditView oldModel={model} assets={assets} />
            )}
        </div>
    );
};

export default PageParent;
